var map = {
	"./auth.de.json": "5250",
	"./auth.en.json": "7a8f",
	"./auth.ru.json": "ea7c",
	"./badges.de.json": "e3dd",
	"./badges.en.json": "402e",
	"./badges.ru.json": "b7cb",
	"./common.de.json": "17b1",
	"./common.en.json": "8996",
	"./common.ru.json": "c936",
	"./companySettings.de.json": "02eb",
	"./companySettings.en.json": "e6ed",
	"./companySettings.ru.json": "a1ae",
	"./contactBlock.de.json": "fee5",
	"./contactBlock.en.json": "e143",
	"./contactBlock.ru.json": "8d8c",
	"./demo.de.json": "50f6",
	"./demo.en.json": "9eed",
	"./demo.ru.json": "a40a",
	"./error.de.json": "a281",
	"./error.en.json": "a101",
	"./error.ru.json": "706c",
	"./mailing.de.json": "6bd7",
	"./mailing.en.json": "8107",
	"./mailing.ru.json": "beeb",
	"./newProfile.de.json": "63d2",
	"./newProfile.en.json": "4010",
	"./newProfile.ru.json": "4623",
	"./newShardList.de.json": "6718",
	"./newShardList.en.json": "02fb7",
	"./newShardList.ru.json": "f124",
	"./newstatistics.de.json": "a54d",
	"./newstatistics.en.json": "18c8",
	"./newstatistics.ru.json": "74fc",
	"./old_de.json": "4369",
	"./old_en.json": "e407",
	"./old_event.de.json": "55a9",
	"./old_event.en.json": "a070",
	"./old_event.ru.json": "64a7",
	"./old_notification.de.json": "d780",
	"./old_notification.en.json": "2a6c",
	"./old_notification.ru.json": "2a8e",
	"./old_ru.json": "2be0",
	"./old_shardList.de.json": "332c",
	"./old_shardList.en.json": "0c0c",
	"./old_shardList.ru.json": "30fe",
	"./old_signin.de.json": "1d91",
	"./old_signin.en.json": "0cc3",
	"./old_signin.ru.json": "b621",
	"./old_statistic.de.json": "1725",
	"./old_statistic.en.json": "0246",
	"./old_statistic.ru.json": "e716",
	"./old_survey.de.json": "7013",
	"./old_survey.en.json": "037f",
	"./old_survey.ru.json": "026e",
	"./old_test.de.json": "f0e3",
	"./old_test.en.json": "09c6",
	"./old_test.ru.json": "ccac",
	"./plan.de.json": "1ae8",
	"./plan.en.json": "4f13",
	"./plan.ru.json": "df27",
	"./products.de.json": "4e19",
	"./products.en.json": "985c",
	"./products.ru.json": "80a1",
	"./productsOld.json": "b510",
	"./sidebar.de.json": "d786",
	"./sidebar.en.json": "85bc",
	"./sidebar.ru.json": "9aff",
	"./support.de.json": "e4cf",
	"./support.en.json": "eb55",
	"./support.ru.json": "35f7",
	"./surveys.de.json": "d205",
	"./surveys.en.json": "cb08",
	"./surveys.ru.json": "7d3c",
	"./table.de.json": "54b0",
	"./table.en.json": "e6ae",
	"./table.ru.json": "5b05",
	"./toolbar.de.json": "e577",
	"./toolbar.en.json": "8460",
	"./toolbar.ru.json": "4241",
	"./tooltip.de.json": "36f6",
	"./tooltip.en.json": "0bed",
	"./tooltip.ru.json": "ce35",
	"./workspace.de.json": "ad2c",
	"./workspace.en.json": "9522",
	"./workspace.ru.json": "2460"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f916";